import { SortDirection } from '@ftr/contracts/api/shared'
import { SelectItem } from '@ftr/forms'
import { ScreenSize } from '@ftr/foundation'
import { SortDirectionText } from '../sort-direction'

/**
 * Various things shared between complex lists are exported here
 */

/**
 * Debounce API requests to prevent button spam
 */
export const REQUEST_DEBOUNCE_MS = 250

/**
 * Screen sizes where we apply filters after clicking the button and not immediately
 */
export const SMALL_SCREEN_SIZES = [ScreenSize.XSmall, ScreenSize.Small, ScreenSize.Medium]

/**
 * A limit of selected checkboxes for some checkbox list filters
 */
export const MAX_SELECTED_OPTIONS = 5
export const MAX_SELECTED_LOCATIONS = 10

const SORT_DIRECTION_ALIAS = {
  [SortDirection.Ascending]: 'Least Recent',
  [SortDirection.Descending]: 'Most Recent',
}

/**
 * Use these when you want to supply ascending/descending options as least/most recent on the front end instead
 */
export const SORT_DIRECTION_ALIASED_SELECT_ITEMS: SelectItem<SortDirection>[] = [
  SortDirection.Descending,
  SortDirection.Ascending,
].map(value => ({ key: SORT_DIRECTION_ALIAS[value], value }))

export const SORT_DIRECTION_TEXT: SortDirectionText = {
  ascending: SORT_DIRECTION_ALIAS[SortDirection.Ascending],
  descending: SORT_DIRECTION_ALIAS[SortDirection.Descending],
}
